/*
 * @Author: Lingxuyue chenxu@libawall.cn
 * @Date: 2023-09-25 15:21:06
 * @LastEditors: The_xu 2596841393@qq.com
 * @LastEditTime: 2025-12-05 16:33:52
 * @FilePath: \yda-qywx-h5\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from "vue-router";
import HomeLayoutControl from "../layouts/homeLayoutControl.vue";
import { GLOBAL_ENUM } from "@/utils/yky/index";
import { environmentJudge, YKY } from "@/utils/utils.js";
// import HomeLayout from "../layouts/homeLayout.vue";
// import { environmentJudge, QYWX, DINGTALK,} from "@/utils/utils.js";
// const environment = environmentJudge()
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/login",
      name: "login",
      meta: {
        title: "登录",
        headHidden: true,
      },
      component: () => import("../views/login/loginPage.vue"),
    },
    {
      path: "/loginPC", // PC登录
      name: "loginPC",
      meta: {
        title: "PC端登录",
      },
      component: () => import("../views/login/loginPC.vue"),
    },
    {
      path: "/privacyPolicy", //隐私政策
      name: "privacyPolicy",
      meta: {
        title: "隐私政策",
      },
      component: () => import("../views/login/PrivacyPolicy.vue"),
    },
     {
          path: "/myLaunch",
          name: "myLaunch",
          meta: {
            title: "我发起的",
            // backHidden: true,
            // padHeadHidden: true,
            padHiddenTitle: true,
          },
          component: () => import("../views/approve/padMyLaunch/index.vue"),
        },
    {
      path: "/",
      name: "/",
      redirect: "/home",
      component: HomeLayoutControl,
      children: [
        {
          path: "/home",
          name: "home",
          meta: {
            rootHeightFill: true,
            title: "首页",
            headHidden: true,
            backHidden: true,
            padHeadHidden: true,
            padHiddenTitle: true,
            darkMode: true,
          },
          component: () =>
            environmentJudge() === YKY
              ? import("../views/homeYKYNew/homeYKYNew.vue")
              : import("../views/home/home.vue"),
        },
        {
          path: "/applyList",
          name: "applyList",
          meta: {
            title: "用印管理",
            backHidden: true,
            padHeadHidden: true,
            padHiddenTitle: true,
            headFixed: true,
          },
          component: () => import("../views/useSeal/applyList/applyList.vue"),
        },
        //pad端用印管理
        {
          path: "/padUseSeal",
          name: "padUseSeal",
          meta: {
            title: "用印管理",
            backHidden: true,
            padHeadHidden: true,
            padHiddenTitle: true,
          },
          component: () => import("../views/useSeal/padUseSeal/index.vue"),
        },
        //我发起的
        // {
        //   path: "/myLaunch",
        //   name: "myLaunch",
        //   meta: {
        //     title: "我发起的",
        //     backHidden: true,
        //     padHeadHidden: true,
        //     padHiddenTitle: true,
        //   },
        //   component: () => import("../views/approve/padMyLaunch/index.vue"),
        // },
        {
          path: "/deviceYKY",
          name: "deviceYKY",
          meta: {
            title: "设备管理",
            backHidden: true,
            padHeadHidden: true,
            padHiddenTitle: true,
          },
          component: () => import("../views/home/home.vue"),
        },
        {
          path: "/enterpriseId",
          name: "enterpriseId",
          meta: {
            title: "申请用印",
          },
          component: () => import("../views/apply/apply.vue"),
        },
        {
          path: "/deviceManage",
          name: "deviceManage",
          meta: {
            title: "设备管理",
            backHidden: true,
            padHeadHidden: true,
            padHiddenTitle: true,
            headFixed: true,
          },
          component: () => import("../views/device/deviceManage/index.vue"),
        },

        {
          path: "/me",
          name: "me",
          meta: {
            rootHeightFill: true,
            title: "个人中心",
            backHidden: true,
            padHeadHidden: true,
            padHiddenTitle: true,
            background: "transparent",
            headFixed: true,
          },
          component: () => import("../views/me/me.vue"),
        },
      ],
    },
    {
          path: "/approveList",
          name: "approveList",
          meta: {
            title: "审批管理",
            // backHidden: true,
            // headFixed: true,
            // padHeadHidden: true,
            // padHiddenTitle: true,
          },
          component: () => import("../views/approve/approveList/approveList.vue"),
        },
    {
      path: "/confirmLogin", //确认登录页
      name: "confirmLogin",
      meta: {
        title: "确认登录",
      },
      component: () => import("../views/scanCode/confirmLogin.vue"),
    },
    {
      path: "/loginPrompt", //登录提示页
      name: "loginPrompt",
      meta: {
        title: "登录提示",
      },
      component: () => import("../views/scanCode/loginPrompt.vue"),
    },
    {
      path: "/apply3", //申请页
      name: "apply3",
      meta: {
        title: "申请用印",
      },
      component: () => import("../views/apply/apply_3.0.vue"),
    },
    {
      path: "/map", //地图页
      name: "map",
      meta: {
        title: "地图选点",
      },
      component: () => import("../views/map/map.vue"),
    },
    {
      path: "/search", //地图搜索页
      name: "search",
      meta: {
        title: "选择外带地点",
      },
      component: () => import("../views/map/search/index.vue"),
    },
    {
      path: "/download", //下载页
      name: "download",
      component: () => import("../views/download/download.vue"),
    },
    {
      path: "/applyDetail", //申请详情
      name: "applyDetail",
      meta: {
        title: "用印详情",
      },
      component: () => import("../views/useSeal/applyDetail/applyDetail.vue"),
    },
    {
      path: "/allMediaImg",
      name: "allMediaImg",
      meta: {
        title: "查看全部图片",
      },
      component: () => import("../views/useSeal/applyDetail/allMedia.vue"),
    },
    {
      path: "/allMediaVideo",
      name: "allMediaVideo",
      meta: {
        title: "查看全部视频",
      },
      component: () => import("../views/useSeal/applyDetail/allMedia.vue"),
    },
    {
      path: "/approveDetails", //审批详情
      name: "approveDetails",
      meta: {
        title: "审批详情",
      },
      component: () => import("../views/approve/approveDetails/approveDetails.vue"),
    },
    {
      path: "/informDetail", //抄送详情
      name: "informDetail",
      meta: {
        title: "抄送详情",
      },
      component: () => import("../views/approve/informDetail/informDetail.vue"),
    },
    {
      path: "/warningList", //预警通知列表
      name: "warningList",
      meta: {
        title: "预警通知",
      },
      component: () => import("../views/notice/warningList/warningList.vue"),
    },
    {
      path: "/warningDetail", //预警详情页
      name: "warningDetail",
      meta: {
        title: "",
      },
      component: () => import("../views/notice/warningDetail/warningDetail.vue"),
    },
    {
      path: "/sysMsgList", // 系统通知列表
      name: "sysMsgList",
      meta: {
        title: "系统通知",
      },
      component: () => import("../views/notice/sysMsg/sysMsgList.vue"),
    },
    {
      path: "/yzgMsgDetail", //印章柜系统通知详情页
      name: "yzgMsgDetail",
      meta: {
        title: "预警详情",
      },
      component: () => import("../views/notice/sysMsg/yzgMsgDetail.vue"),
    },
    {
      path: "/ocrDetail", //预警详情页
      name: "ocrDetail",
      meta: {
        title: "预警详情",
      },
      component: () => import("../views/notice/ocrDetail/ocrDetail.vue"),
    },
    {
      path: "/ocrView", //预警详情页
      name: "ocrView",
      meta: {
        title: " ",
        padHeadFixed: true,
        padHiddenTitle: true,
        background: "transparent",
        color: "#ffffff",
        // headHidden: true,
      },
      component: () => import("../views/notice/ocrDetail/ocrView.vue"),
    },
    {
      path: "/remoteConfirm", // 系统通知-远程确认人页
      name: "remoteConfirm",
      meta: {
        title: "远程盖印确认",
      },
      component: () => import("../views/notice/sysMsg/remoteConfirm.vue"),
    },
    {
      path: "/remoteOcrDiff", // 系统通知-远程确认人页 OCR 对比预览
      name: "remoteOcrDiff",
      meta: {
        title: "OCR 对比预览",
      },
      component: () => import("../views/notice/sysMsg/remoteOcrDiff.vue"),
    },
    {
      path: "/ykyRemoteOcrDiff", // 系统通知-远程确认人页 OCR 对比预览
      name: "ykyRemoteOcrDiff",
      meta: {
        title: "OCR 对比预览",
      },
      component: () => import("../views/notice/sysMsg/ykyRemoteOcrDiff.vue"),
    },
    {
      path: "/sealPeople", // 申请用印-远程确认人选择页
      name: "sealPeople",
      meta: {
        title: "选择远程确认人",
      },
      component: () => import("../views/apply/sealPeople.vue"),
    },
    {
      path: "/temporaryPeople", // 申请用印-远程确认人选择页
      name: "temporaryPeople",
      meta: {
        title: "选择人员",
      },
      component: () => import("../views/useSeal/components/selectPerson.vue"),
    },
    {
      path: "/phone", // 申请用印-远程确认人选择页
      name: "phone",
      meta: {
        title: "选择手机号",
      },
      component: () => import("../views/phone/index.vue"),
    },
    {
      path: "/deviceDetail", // 设备详情页
      name: "deviceDetail",
      meta: {
        title: "设备详情",
      },
      component: () => import("../views/device/deviceDetail/index.vue"),
    },
    {
      path: "/connectDevice", // 连接设备页
      name: "connectDevice",
      meta: {
        title: "连接设备",
      },
      component: () => import("../views/device/connectDevice/index.vue"),
    },
    {
      path: "/facePhoto", // 连接设备页
      name: "facePhoto",
      meta: {
        title: "环境影像",
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.TRANSPARENT_THEME,
      },
      component: () => import("../views/device/facePhoto/index.vue"),
    },
    {
      path: "/waitUse", // 待用印
      name: "waitUse",
      meta: {
        title: "待用印",
      },
      component: () => import("../views/waitUse/index.vue"),
    },
    {
      path: "/useRecord", // 用印记录
      name: "useRecord",
      meta: {
        title: "用印记录",
        padHeadHidden: false,
        padHiddenTitle: true,
      },
      component: () => import("../views/useRecord/recordPageControl/index.vue"),
    },
    {
      path: "/chooseSeal", // 选择印章页
      name: "chooseSeal",
      meta: {
        title: "选择印章",
      },
      component: () => import("../views/device/chooseSeal/index.vue"),
    },
    {
      path: "/installSeal", // 装卸印章
      name: "installSeal",
      meta: {
        title: "装卸印章",
      },
      component: () => import("../views/device/installSeal/index.vue"),
    },
    {
      path: "/recordDetail", // 用印记录
      name: "recordDetail",
      meta: {
        title: "记录详情",
      },
      component: () => import("../views/useRecord/detail/index.vue"),
    },
    {
      path: "/selectPeople", // 录入指纹选择人员
      name: "selectPeople",
      meta: {
        title: "选择人员",
      },
      component: () => import("../views/device/selectPeople/index.vue"),
    },
    {
      path: "/enteringFingerprint", // 录入指纹
      name: "enteringFingerprint",
      meta: {
        title: "录入指纹",
      },
      component: () => import("../views/device/enteringFingerprint/index.vue"),
    },
    {
      path: "/fingerprint", // 指纹管理
      name: "fingerprint",
      meta: {
        title: "指纹管理",
      },
      component: () => import("../views/device/fingerprint/index.vue"),
    },
    {
      path: "/dipInk", // 蘸墨
      name: "dipInk",
      meta: {
        title: "蘸墨",
      },
      component: () => import("../views/device/dipInk/index.vue"),
    },
    {
      path: "/addInk", // 加墨
      name: "addInk",
      meta: {
        title: "加墨",
      },
      component: () => import("../views/device/addInk/index.vue"),
    },
    {
      path: "/exportPdf", // 加墨
      name: "exportPdf",
      meta: {
        title: "选择图片",
      },
      component: () => import("../views/useRecord/exportPdf/index.vue"),
    },
    {
      path: "/upgradeDevice", // 固件升级
      name: "upgradeDevice",
      meta: {
        title: "固件升级",
      },
      component: () => import("../views/device/upgradeDevice/index.vue"),
    },
    {
      path: "/upgradeOta", // 固件升级
      name: "upgradeOta",
      meta: {
        title: "镜像升级",
      },
      component: () => import("../views/device/upgradeOta/index.vue"),
    },
    {
      path: "/envChange",
      name: "envChange",
      meta: {
        title: "环境切换",
      },
      component: () => import("../views/device/envChange/index.vue"),
    },
    {
      path: "/connectChange",
      name: "connectChange",
      meta: {
        title: "通讯配置",
      },
      component: () => import("../views/device/connectChange/connectChange.vue"),
    },
    {
      path: "/sealSetting", // 远程锁定  影像管理
      name: "sealSetting",
      meta: {
        title: "",
      },
      component: () => import("../views/device/sealSetting/index.vue"),
    },
    {
      path: "/openDevice", // 紧急开仓
      name: "openDevice",
      meta: {
        title: "紧急开仓",
      },
      component: () => import("../views/device/openDevice/index.vue"),
    },
    {
      path: "/findDevices", // 一键寻印
      name: "findDevices",
      meta: {
        title: "查找印章",
      },
      component: () => import("../views/device/findDevices/index.vue"),
    },
    {
      path: "/wifi", // 一键寻印
      name: "wifi",
      meta: {
        title: "网络设置",
      },
      component: () => import("../views/device/wifiSetting/index.vue"),
    },
    {
      path: "/chooseDevice", // 开始用印 到 选择印章
      name: "chooseDevice",
      meta: {
        title: "选择印章",
      },
      component: () => import("../views/device/chooseDevice/index.vue"),
    },
    {
      path: "/testFingerprint", // 验证指纹（常规盖印）
      name: "testFingerprint",
      meta: {
        title: "（常规）盖印中",
      },
      component: () => import("../views/device/testFingerprint/index.vue"),
    },
    {
      path: "/remake", // 补拍
      name: "remake",
      meta: {
        title: "补拍",
        background: "transparent",
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.TRANSPARENT_THEME,
        padHeadFixed: true,
        padHiddenTitle: true,
        color: "white",
      },
      component: () => import("../views/useRecord/remake/index.vue"),
    },
    {
      path: "/ocrRemake", // ocr拍照
      name: "ocrRemake",
      meta: {
        title: "OCR拍照",
      },
      component: () => import("../views/device/ocrRemake/index.vue"),
    },
    {
      path: "/normalPrint", // 常规盖印
      name: "normalPrint",
      meta: {
        title: "（常规）盖印中",
      },
      component: () => import("../views/device/normalPrint/index.vue"),
    },
    {
      path: "/remotePrint", // 远程盖印
      name: "remotePrint",
      meta: {
        title: "（远程）盖印中",
      },
      component: () => import("../views/device/remotePrint/index.vue"),
    },
    {
      path: "/remotePrintResult", // 远程盖印
      name: "remotePrintResult",
      meta: {
        title: "（远程）盖印中",
      },
      component: () => import("../views/device/remotePrintResult/index.vue"),
    },
    {
      path: "/continuousPrint", // 连续盖印
      name: "continuousPrint",
      meta: {
        title: "（连续）盖印中",
      },
      component: () => import("../views/device/continuousPrint/index.vue"),
    },
    {
      path: "/updating", // 固件升级
      name: "updating",
      meta: {
        title: "固件升级",
      },
      component: () => import("../views/device/updating/index.vue"),
    },
    {
      path: "/applyCover",
      name: "applyCover",
      meta: {
        title: "申请补盖",
      },
      component: () => import("../views/applyCover/index.vue"),
    },
    {
      path: "/normalContinuous",
      name: "normalContinuous",
      meta: {
        title: "（连续）盖印中",
      },
      component: () => import("../views/device/normalContinuous/index.vue"),
    },
    {
      //常规盖印开启了录制视频
      path: "/qrcodePrintCamera",
      name: "qrcodePrintCamera",
      meta: {
        title: "（常规）盖印中",
      },
      component: () => import("../views/device/qrcodePrintCamera/index.vue"),
    },
    {
      path: "/chooseFile",
      name: "chooseFile",
      meta: { title: "选择文件", padHeadFixed: true, padHeadHidden: true },
      component: () => import("../views/device/chooseFileContorl/index.vue"),
    },
    {
      path: "/archive", //归档
      name: "archive",
      meta: {
        title: "文件归档",
      },
      component: () => import("../views/archive/archive.vue"),
    },
    {
      path: "/sealChangeSure", //装卸换
      name: "sealChangeSure",
      meta: {
        title: "装卸印章",
      },
      component: () => import("../views/sealChange/sealChangeSure.vue"),
    },
    {
      path: "/adbPage",
      name: "adbPage",
      meta: {
        title: "影像上传",
      },
      component: () => import("../views/adbPage/index.vue"),
    },
    {
      path: "/sealChangeApply", //装卸换申请
      name: "sealChangeApply",
      meta: {
        title: "印章装卸申请",
      },
      component: () => import("../views/sealChange/sealChangeApply.vue"),
    },
    {
      path: "/sealOperation", //装卸换申请
      name: "sealOperation",
      meta: {
        title: "印章装卸申请",
      },
      component: () => import("../components/DiyCard/SealOperation/index.vue"),
    },
    {
      path: "/stampingInformation", //用印信息
      name: "stampingInformation",
      meta: {
        title: "用印信息",
      },
      component: () => import("../views/stampingInformation/index.vue"),
    },
    {
      path: "/goodsApply", //物品申请领用
      name: "goodsApply",
      meta: {
        title: "申请领用",
      },
      component: () => import("../views/goodsApply/index.vue"),
    },
    {
      path: "/addTemporary",
      name: "addTemporary",
      meta: {
        title: "新增临时盖印人",
      },
      component: () => import("../views/useSeal/components/addTemporary.vue"),
    },
    // APP使用 扫一扫页面
    {
      path: "/scanCode",
      name: "scanCode",
      meta: {
        title: "扫一扫",
        background: "transparent",
        color: "white",
      },
      component: () => import("../views/home/scanCode/index.vue"),
    },
    {
      path: "/loginAccount",
      name: "loginAccount",
      meta: {
        title: "账户登录",
        headHidden: true,
        padHeadHidden: true,
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.LINEAR_GRADIENT_THEME,
      },
      component: () => import("../views/loginAccount/index.vue"),
    },
    {
      path: "/forgotPwd",
      name: "forgotPwd",
      meta: {
        title: "忘记密码",
        headHidden: true,
      },
      component: () => import("../views/forgotPwd/index.vue"),
    },
    {
      path: "/feedback",
      name: "feedback",
      meta: {
        title: "意见反馈",
        headHidden: false,
      },
      component: () => import("../views/feedback/index.vue"),
    },
    {
      path: "/setup",
      name: "setup",
      meta: {
        title: "设置",
        headHidden: false,
      },
      component: () => import("../views/setup/index.vue"),
    },
    {
      path: "/changePwd",
      name: "changePwd",
      meta: {
        title: "修改密码",
        headHidden: false,
      },
      component: () => import("../views/changePwd/index.vue"),
    },
    {
      path: "/setPwd",
      name: "setPwd",
      meta: {
        title: "设置密码",
        headHidden: false,
      },
      component: () => import("../views/setPwd/index.vue"),
    },
    {
      path: "/changeAccount",
      name: "changeAccount",
      meta: {
        title: "更换账号",
        headHidden: false,
      },
      component: () => import("../views/changeAccount/index.vue"),
    },
    {
      path: "/changeAccountConfirm",
      name: "changeAccountConfirm",
      meta: {
        title: "更换账号",
      },
      component: () => import("../views/changeAccountConfirm/index.vue"),
    },
    {
      path: "/about",
      name: "about",
      meta: {
        title: "关于玺得安",
      },
      component: () => import("../views/about/index.vue"),
    },
    {
      path: "/changeAvatar",
      name: "changeAvatar",
      meta: {
        title: "更换头像",
        background: "#131314",
        color: "white",
      },
      component: () => import("../views/changeAvatar/index.vue"),
    },
    {
      path: "/changeAvatar",
      name: "changeAvatar",
      meta: {
        title: "更换头像",
        background: "#131314",
        color: "white",
      },
      component: () => import("../views/changeAvatar/index.vue"),
    },
    {
      path: "/changeAvatarCamera",
      name: "changeAvatarCamera",
      meta: {
        title: "更换头像",
        background: "transparent",
        color: "white",
      },
      component: () => import("../views/changeAvatar/camera/index.vue"),
    },

    {
      path: "/changeAvatarConfirm",
      name: "changeAvatarConfirm",
      meta: {
        title: "更换头像",
        background: "#131314",
        color: "white",
      },
      component: () => import("../views/changeAvatar/confirm/index.vue"),
    },
    {
      path: "/useDevice", // 常规盖印
      name: "useDevice",
      meta: {
        title: "盖印中",
        padHeadHidden: true,
        padHeadFixed: true,
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.TRANSPARENT_THEME,
      },
      component: () => import("../views/device/useDeviceContorl/index.vue"),
    },
    {
      path: "/assetsUpgrades",
      name: "assetsUpgrades",
      meta: {
        title: "资源更新",
        headHidden: true,
      },
      component: () => import("../views/upgrades/index.vue"),
    },
    {
      path: "/longRange",
      name: "longRange",
      meta: {
        title: "(远程) 盖印中",
        background: "transparent",
        color: "white",
        customHead: true,
      },
      component: () => import("../views/longRange/index.vue"),
    },
    {
      path: "/longRangeSeal",
      name: "longRangeSeal",
      meta: {
        title: "(远程) 盖印中",
      },
      component: () => import("../views/longRange/seal.vue"),
    },
    {
      path: "/pdfPreview",
      name: "pdfPreview",
      meta: {
        title: "文件预览",
      },
      component: () => import("../views/pdfPreview/index.vue"),
    },
    {
      path: "/ykySetting",
      name: "ykySetting",
      meta: {
        title: "设置",
        padHeadHidden: false,
        padHiddenTitle: true,
      },
      component: () => import("../views/ykySetting/index.vue"),
    },
    {
      path: "/ykyWifiSetting",
      name: "ykyWifiSetting",
      meta: {
        title: "wifi设置",
        padHeadHidden: false,
        padHiddenTitle: true,
      },
      component: () => import("../views/ykySetting/wifiSetting/index.vue"),
    },
    {
      path: "/ykyAbout",
      name: "ykyAbout",
      meta: {
        title: "关于我们",
        padHeadHidden: false,
        padHiddenTitle: true,
      },
      component: () => import("../views/ykySetting/about/index.vue"),
    },
    {
      path: "/stampCode",
      name: "stampCode",
      meta: {
        title: "盖印码",
        padHeadHidden: true,
        padHiddenTitle: true,
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.LINEAR_GRADIENT_THEME,
        darkMode: true,
      },
      component: () => import("../views/loginAccount/stampCode/index.vue"),
    },
    {
      path: "/stampCodeHome",
      name: "stampCodeHome",
      meta: {
        title: "盖印码",
        // padHeadHidden: true,
        padHiddenTitle: true,
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.LINEAR_GRADIENT_THEME,
        darkMode: true,
      },
      component: () => import("../views/loginAccount/stampCode/index.vue"),
    },
    {
      path: "/ocrBeforePhoto",
      name: "ocrBeforePhoto",
      meta: {
        title: "OCR拍照前",
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.LINEAR_GRADIENT_THEME,
      },
      component: () => import("../views/device/useDeviceContorl/ceshi/ocrBeforePhoto.vue"),
    },
    {
      path: "/ocrCamera",
      name: "ocrCamera",
      meta: {
        padHeadHidden: false,
        padHeadFixed: true,
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.TRANSPARENT_THEME,
      },
      component: () => import("../views/device/useDeviceContorl/ceshi/ocrCamera.vue"),
    },
    {
      path: "/allPhoto",
      name: "allPhoto",
      meta: {
        padHeadHidden: false,
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.LINEAR_GRADIENT_THEME,
      },
      component: () => import("../views/device/useDeviceContorl/ceshi/allPhoto.vue"),
    },
    {
      path: "/ykyFingerprint",
      name: "ykyFingerprint",
      meta: {
        title: "指纹管理",
      },
      component: () => import("../views/ykySetting/ykyFingerprint/index.vue"),
    },
    {
      path: "/stampedVideoList", //盖印视频列表
      name: "stampedVideoList",
      meta: {
        title: "盖印视频",
      },
      component: () => import("../components/DiyCard/ApplySeal/StampedVideoList/index.vue"),
    },
    {
      path: "/fileUploadArchiveYky",
      name: "fileUploadArchiveYky",
      meta: {
        title: "文件上传",
      },
      component: () =>
        import("../components/DiyForms/FileUploadArchive/YKY/FileUploadArchiveYky.vue"),
    },
    {
      path: "/fileUploadYky", // 拍照
      name: "fileUploadYky",
      meta: {
        title: "用印后文件拍照",
        background: "transparent",
        bodyBackground: GLOBAL_ENUM.THEME_TYPE.TRANSPARENT_THEME,
        padHeadFixed: true,
        padHiddenTitle: true,
        color: "white",
      },
      component: () => import("@/components/DiyForms/FileUploadArchive/YKY/takePhoto.vue"),
    },
    {
      path: "/applyStampingDetail", // 用印详情
      name: "applyStampingDetail",
      meta: {
        title: "文件详情"
      },
      component: () => import("@/views/elecSeal/applyStamping/detail/index.vue"),
    },
  ],
});

export default router;
